import { useTranslation } from 'react-i18next';

import { useProductCenterApi } from 'api';
import { getUrlHealthCheckFileDownload } from 'api/ApiUrls';
import { HealthCheckFileDto } from 'api/v1/data-contracts';
import { PrintableAttachmentsSection } from 'modules/Shared/PdfPrint/PrintableAttachmentsSection';

interface PrintableAttachmentsProps {
	attachments: HealthCheckFileDto[];
}

export const PrintableAttachments = ({
	attachments,
}: PrintableAttachmentsProps) => {
	const { t } = useTranslation(['healthCheck']);
	const { api } = useProductCenterApi();

	return (
		<PrintableAttachmentsSection
			attachments={attachments}
			sectionTitle={t(
				'healthCheck:healthCheckPrintout-additionalFilesToPrint'
			)}
			printFailedMessage={t(
				'healthCheck:healthCheckPrintout-print-failed'
			)}
			getFileUrl={(attachment) =>
				getUrlHealthCheckFileDownload(attachment.id)
			}
			onDownload={async (attachment) =>
				(
					await api.downloadHealthCheckDocument(attachment.id, {
						format: 'blob',
					})
				).data as unknown as Blob
			}
		/>
	);
};
